export default __webpack_public_path__ + "static/media/pop_hazards_camera.08bd982b.svg";